import { ethereum } from "../../../../chains/chain-definitions/ethereum.js";
import { socialAuthOptions, } from "../../../../wallets/types.js";
/**
 * Checks if the provided wallet is an in-app wallet.
 *
 * @param wallet - The wallet to check.
 * @returns True if the wallet is an in-app wallet, false otherwise.
 */
export function isInAppWallet(wallet) {
    return wallet.id === "inApp" || wallet.id === "embedded";
}
/**
 * @internal
 */
export async function connectInAppWallet(options, createOptions, connector) {
    if (
    // if auth mode is not specified, the default is popup
    createOptions?.auth?.mode !== "popup" &&
        createOptions?.auth?.mode !== undefined &&
        connector.authenticateWithRedirect) {
        const strategy = options.strategy;
        if (socialAuthOptions.includes(strategy)) {
            connector.authenticateWithRedirect(strategy, createOptions?.auth?.mode, createOptions?.auth?.redirectUrl);
        }
    }
    // If we don't have authenticateWithRedirect then it's likely react native, so the default is to redirect and we can carry on
    // IF WE EVER ADD MORE CONNECTOR TYPES, this could cause redirect to be ignored despite being specified
    // TODO: In V6, make everything redirect auth
    const authResult = await connector.connect(options);
    const authAccount = authResult.user.account;
    if (createOptions &&
        "smartAccount" in createOptions &&
        createOptions?.smartAccount) {
        return convertToSmartAccount({
            client: options.client,
            authAccount,
            smartAccountOptions: createOptions.smartAccount,
            chain: options.chain,
        });
    }
    return [authAccount, options.chain || ethereum];
}
/**
 * @internal
 */
export async function autoConnectInAppWallet(options, createOptions, connector) {
    if (options.authResult && connector.loginWithAuthToken) {
        await connector.loginWithAuthToken(options.authResult);
    }
    const user = await getAuthenticatedUser(connector);
    if (!user) {
        throw new Error("Failed to authenticate user.");
    }
    const authAccount = user.account;
    if (createOptions &&
        "smartAccount" in createOptions &&
        createOptions?.smartAccount) {
        return convertToSmartAccount({
            client: options.client,
            authAccount,
            smartAccountOptions: createOptions.smartAccount,
            chain: options.chain,
        });
    }
    return [authAccount, options.chain || ethereum];
}
async function convertToSmartAccount(options) {
    const [{ smartWallet }, { connectSmartWallet }] = await Promise.all([
        import("../../../smart/smart-wallet.js"),
        import("../../../smart/index.js"),
    ]);
    const sa = smartWallet(options.smartAccountOptions);
    return connectSmartWallet(sa, {
        client: options.client,
        personalAccount: options.authAccount,
        chain: options.chain,
    }, options.smartAccountOptions);
}
async function getAuthenticatedUser(connector) {
    const user = await connector.getUser();
    switch (user.status) {
        case "Logged In, Wallet Initialized": {
            return user;
        }
    }
    return undefined;
}
//# sourceMappingURL=index.js.map